const INITIAL_STATE = {
    data: [],
    count: 0,
    point: [],
    loading: false
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case "GET_POINTS": {
        return {
          ...state,
          data: action.data,
          count: action.count,
          loading: false
        }
      }
      case "GET_POINT": {
        return {
          ...state,
          point: action.data,
          loading: false
        }
      }
      default:
        return state
    }
  }
  